import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { handleMutationResult } from '@/helpers/toastHelper';
import { useGetEmployeeSkillsQuery, useUpdateEmployeeSkillsMutation } from '@/services/gql/graphql.generated';
import { FC, useState } from 'react';
import strings from '../../team.translations';
import { useNavigate } from 'react-router-dom';
import { useActiveSkills } from '@/services/tasks/useSkills';
import { Checkbox } from '@/components/shared/checkboxes/Checkbox';

interface SkillsEditForm {
  userId: string;
  initSkillIds: string[];
}

export const SkillsEditForm: FC<SkillsEditForm> = ({ userId, initSkillIds }) => {
  const [checkedSkillList, setCheckedSkillList] = useState<string[]>(initSkillIds);

  const skills = useActiveSkills();

  const [{ fetching }, updateSkills] = useUpdateEmployeeSkillsMutation();
  const navigate = useNavigate();

  const [, refetch] = useGetEmployeeSkillsQuery({ variables: { employeeIds: [userId] } });

  const onCheck = (skillId: string) => {
    let newSkillList = [...checkedSkillList];

    if (newSkillList.includes(skillId)) {
      newSkillList = newSkillList.filter(s => s !== skillId);
    } else {
      newSkillList.push(skillId);
    }

    setCheckedSkillList(newSkillList);
  };

  const goBack = () => {
    navigate(-1);
  };

  const onSubmit = async () => {
    const result = await updateSkills({
      skills: [{ employeeId: userId, skills: checkedSkillList.map(s => ({ skillId: s, rating: 5 })) }]
    });

    await refetch({ requestPolicy: 'network-only' });
    setTimeout(
      () =>
        handleMutationResult(result, {
          successMessage: 'Skills successfully updated.',
          onSuccess: () => {
            goBack();
          }
        }),
      100
    );
  };

  return (
    <>
      <TSTitleCard title="Edit Skills">
        <div className="grid grid-cols-3 gap-2">
          {skills.map(skill => (
            <div key={skill.id}>
              <Checkbox
                label={skill.displayName}
                checked={checkedSkillList.includes(skill.id)}
                onChange={() => onCheck(skill.id)}
              ></Checkbox>
            </div>
          ))}
        </div>
      </TSTitleCard>
      <div className="space-y-5 max-w-3xl mx-auto pt-5 pl-5">
        <div className="flex w-full items-center justify-end gap-5">
          <Button onClick={goBack}>{strings.common.cancel}</Button>
          <Button primary loading={fetching} onClick={onSubmit}>
            {strings.common.save}
          </Button>
        </div>
      </div>
    </>
  );
};
